"use client";

import dynamic from "next/dynamic";

const HeaderDesktop = dynamic(
  () => import("./Desktop").then((mod) => mod.HeaderDesktop),
  { ssr: false },
);
const MobileDesktop = dynamic(
  () => import("./Mobile").then((mod) => mod.MobileDesktop),
  { ssr: false },
);

interface HeaderClientProps {
  locales: string[];
  locale: string;
}

export const HeaderClient = ({ locales, locale }: HeaderClientProps) => {
  return (
    <>
      <HeaderDesktop
        locales={locales}
        locale={locale}
      />
      <MobileDesktop
        locales={locales}
        locale={locale}
      />
    </>
  );
};
